"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Vue, Watch } from "vue-property-decorator";
import { Debounce } from "vue-debounce-decorator";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import API from "@ym-framework/api-utils";
import DateFormat from "@/framework/timeformatter";
let WebResourceRequestList = class extends Vue {
  constructor() {
    super(...arguments);
    // request_list_type: string = "apply";
    this.search_input = "";
    this.imageDialogVisible = false;
    this.currentImageUrl = "";
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v1/webpage-access-applys")
    );
  }
  onRequestListTypeChanged(newVal, oldVal) {
    return __async(this, null, function* () {
      this.gridController.query.filter = `auditStatus=='${newVal}'`;
      yield this.gridController.search();
    });
  }
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.query.params = {
        "type": "MONITOR"
      };
      this.gridController.query.filter = `auditStatus=='${this.request_list_type}'`;
      yield this.gridController.search();
    });
  }
  refresh() {
    return __async(this, null, function* () {
      this.gridController.query.params = {
        "type": "MONITOR"
      };
      this.gridController.query.filter = `auditStatus=='${this.request_list_type}'`;
      yield this.gridController.search();
    });
  }
  changerequestType(data) {
    return __async(this, null, function* () {
      this.gridController.query.params = {
        "type": "MONITOR"
      };
      this.gridController.query.filter = `auditStatus=='${data}'`;
      yield this.gridController.search();
    });
  }
  format_date(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
  searchName() {
    return __async(this, null, function* () {
      try {
        if (this.search_input !== null && this.search_input !== "") {
          this.gridController.query.filter = `shopName == '%${this.search_input}%';auditStatus=='${this.request_list_type}'`;
        }
        if (this.search_input === null || this.search_input === "") {
          this.gridController.query.filter = `auditStatus=='${this.request_list_type}'`;
        }
        this.gridController.query.params = {
          "type": "MONITOR"
        };
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  passRequest(row) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v1/webpage-access-applys`, {
          "id": row.id,
          "status": "approve"
        });
        this.$message.success(this.$t("web_resource_request.pass_monitor_request_success"));
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  refuseRequest(row) {
    return __async(this, null, function* () {
      try {
        yield API.put(`api://base.auth/api/v1/webpage-access-applys`, {
          "id": row.id,
          "status": "reject"
        });
        this.$message.success(this.$t("web_resource_request.refuse_monitor_request_success"));
        yield this.refresh();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  showImageDialog(imageUrl) {
    this.currentImageUrl = imageUrl;
    this.imageDialogVisible = true;
  }
};
__decorateClass([
  PropSync("request_list_typed", { type: String, default: "apply" })
], WebResourceRequestList.prototype, "request_list_type", 2);
__decorateClass([
  Watch("request_list_type")
], WebResourceRequestList.prototype, "onRequestListTypeChanged", 1);
__decorateClass([
  Debounce(400)
], WebResourceRequestList.prototype, "changerequestType", 1);
__decorateClass([
  Debounce(400)
], WebResourceRequestList.prototype, "searchName", 1);
WebResourceRequestList = __decorateClass([
  Component({
    components: {
      UiGrid
    }
  })
], WebResourceRequestList);
export {
  WebResourceRequestList as default
};
